import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import './style.css';

export default class Slider extends Component {
  static defaultProps = {
    autoplay: 0,
    wrapParagraph: false,
  };

  state = { index: 0 };

  x0 = null;
  x = 0;
  y0 = null;
  y = 0;

  intervalId = null;

  componentDidMount() {
    if (this.props.autoplay) {
      this.initAutoplay();
    }
  }

  componentWillUnmount() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }

  initAutoplay = () => {
    this.intervalId = setInterval(this.goToNextSlide, this.props.autoplay);
  };

  getItems = () =>
    typeof this.props.items === 'function'
      ? this.props.items(this.state.index)
      : this.props.items;

  goToNextSlide = () => {
    const items = this.getItems();
    if (this.state.index === items.length - 1) {
      this.goToSlide(0);
      return;
    }
    this.setState(prevState => ({
      index: prevState.index + 1,
    }));
  };

  goToSlide = index => {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
    this.setState({ index: index }, () => {
      if (this.props.autoplay) {
        this.initAutoplay();
      }
    });
  };

  onTouchStart = e => {
    this.x0 = e.touches[0].clientX;
    this.y0 = e.touches[0].clientY;
  };

  onTouchMove = e => {
    const x0 = this.x0;

    if (x0 === null) {
      return;
    }

    this.x = e.touches[0].clientX;
    this.y = e.touches[0].clientY;
  };

  onTouchEnd = e => {
    const items = this.getItems();
    let index = this.state.index;
    const dX = this.x0 - this.x;
    const dY = this.y0 - this.y;
    console.log(Math.abs(dX));

    if (Math.abs(dX) < 40 && Math.abs(dY) < Math.abs(dX) && Math.abs(dX) > 25) {
      console.log('return');
      e.stopPropagation();
      e.preventDefault();
    }

    if (Math.abs(dY) > Math.abs(dX)) {
      this.x0 = null;
      this.y0 = null;
      return;
    }

    index = dX > 0 ? index + 1 : index - 1;
    index = this.mod(index, items.length);

    this.x0 = null;
    this.y0 = null;
    this.goToSlide(index);
  };

  onMouseDown = e => {
    this.x0 = e.clientX;
  };

  onMouseMove = e => {
    const x0 = this.x0;

    if (x0 === null) {
      return;
    }

    this.x = e.clientX;
    this.y = e.clientY;
  };

  onMouseUp = () => {
    const items = this.getItems();
    let index = this.state.index;
    const dX = this.x0 - this.x;
    const dY = this.y0 - this.y;

    if (Math.abs(dY) > Math.abs(dX)) {
      this.x0 = null;
      this.y0 = null;
      return;
    }

    index = dX > 0 ? index + 1 : index - 1;
    index = this.mod(index, items.length);

    this.x0 = null;
    this.y0 = null;
    this.goToSlide(index);
  };

  mod(n, m) {
    return ((n % m) + m) % m;
  }

  render() {
    const { index } = this.state;
    const { wrapParagraph, ...props } = this.props;

    const items = this.getItems();

    return (
      <div
        onTouchStart={this.onTouchStart}
        onTouchMove={this.onTouchMove}
        onTouchEnd={this.onTouchEnd}
        onMouseDown={this.onMouseDown}
        onMouseMove={this.onMouseMove}
        onMouseUp={this.onMouseUp}
        className={classnames('slider', props.className || '')}
      >
        <ul className="slider-content">
          {items.map((item, i) => (
            <li
              className={i === index ? 'active' : null}
              key={i}
              style={{
                transform: `translateX(calc(-100% * ${index}))`,
                overflow: 'visible',
              }}
            >
              {wrapParagraph ? <p>{item}</p> : item}
            </li>
          ))}
        </ul>

        <ul className="slider-controller">
          {items.map((_, i) => (
            <li key={i}>
              <a
                className={i === index ? 'active' : null}
                onClick={() => this.goToSlide(i)}
                tabIndex={-1}
              ></a>
            </li>
          ))}
        </ul>
      </div>
    );
  }
}

Slider.propTypes = {
  items: PropTypes.oneOfType([PropTypes.array, PropTypes.func]),
  autoplay: PropTypes.number,
  wrapParagraph: PropTypes.bool,
};
